export const getCommonLocationIds = (selectedLocations: number[][]) => {
  if (selectedLocations.length === 0) {
    return new Set([]);
  }

  const commonLocationIds = new Set(selectedLocations[0]);

  selectedLocations.slice(1).forEach((locations) => {
    const locationIds = new Set(locations);
    for (const id of commonLocationIds) {
      if (!locationIds.has(id)) {
        commonLocationIds.delete(id);
      }
    }
  });

  return commonLocationIds;
};

export const getCommonLocations = (
  selectedLocations: { id: number; name: string }[][],
) => {
  if (selectedLocations.length === 0) {
    return new Set([]);
  }

  const commonLocations = new Set(selectedLocations[0]);

  selectedLocations.slice(1).forEach((locations) => {
    const locationIds = new Set(locations.map((i) => i.id));
    for (const loc of commonLocations) {
      if (!locationIds.has(loc.id)) {
        commonLocations.delete(loc);
      }
    }
  });

  return commonLocations;
};
